import { NgModule } from '@angular/core';
import {MenubarModule} from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import {AvatarModule} from 'primeng/avatar';
import {AvatarGroupModule} from 'primeng/avatargroup';
import {TableModule} from 'primeng/table';
import {PanelModule} from 'primeng/panel';
import {ToolbarModule} from 'primeng/toolbar';
import {SplitterModule} from 'primeng/splitter';
import {BadgeModule} from 'primeng/badge';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CalendarModule } from 'primeng/calendar';
import { ChipModule } from 'primeng/chip';
import {TooltipModule} from 'primeng/tooltip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider'
import {MenuModule} from 'primeng/menu';
import { TagModule } from 'primeng/tag';
import { FileUpload } from 'primeng/fileupload';
import { ProgressBar } from 'primeng/progressbar';
import { TabsModule } from 'primeng/tabs';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectModule } from 'primeng/select';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CardModule } from 'primeng/card';
import { AccordionModule } from 'primeng/accordion';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MessageModule } from 'primeng/message';

@NgModule({
  imports: [
    SplitButtonModule,
    AccordionModule,
    MessageModule,
    CardModule,
    FloatLabelModule,
    SelectModule,
    ToggleButtonModule,
    ToggleSwitchModule,
    FileUpload,
    ProgressBar,
    TagModule,
    RadioButtonModule,
    CalendarModule,
    MenubarModule,
    InputTextModule,
    ButtonModule,
    AvatarModule,
    AvatarGroupModule,
    TableModule,
    PanelModule,
    ToolbarModule,
    SplitterModule,
    BadgeModule,
    PasswordModule,
    CheckboxModule,
    InputNumberModule,
    DropdownModule,
    ProgressSpinnerModule,
    ChipModule,
    TooltipModule,
    BreadcrumbModule,
    MultiSelectModule,
    DialogModule,
    DividerModule,
    MenuModule,
    TabsModule,
  ],
  declarations: [],
  exports: [
    SplitButtonModule,
    AccordionModule,
    MessageModule,
    CardModule,
    SelectModule,
    ToggleButtonModule,
    ToggleSwitchModule,
    FileUpload,
    ProgressBar,
    TagModule,
    RadioButtonModule,
    MenubarModule,
    InputTextModule,
    ButtonModule,
    AvatarModule,
    AvatarGroupModule,
    TableModule,
    PanelModule,
    ToolbarModule,
    SplitterModule,
    BadgeModule,
    PasswordModule,
    CheckboxModule,
    InputNumberModule,
    DropdownModule,
    ProgressSpinnerModule,
    CalendarModule,
    ChipModule,
    TooltipModule,
    BreadcrumbModule,
    MultiSelectModule,
    DialogModule,    
    DividerModule,
    MenuModule,
    TabsModule
  ],
  providers: []
})
export class PrimeNgAngularModule { }
